import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { ref, computed, onMounted, watch, onUnmounted } from 'vue'
import { useGolfHeaderStore } from '@/store/golf-header'
import CommonError from '@/components/CommonError.vue'
import Loader from '@/components/Loader.vue'
import GolfCarInfoSection from './GolfCarInfoSection.vue'
import GolfCarAssetsSection from './GolfCarAssetsSection.vue'
import { useGolfVehiclesStore } from '@/store/golf-vehicles'

const LS_TAB_KEY = 'golf_car_details_active_tab'

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props

const golfStore = useGolfVehiclesStore()
const headerStore = useGolfHeaderStore()

const activeTab = ref(localStorage.getItem(LS_TAB_KEY) || 'golf-car-info')

watch(activeTab, tab => {
  localStorage.setItem(LS_TAB_KEY, tab)
})

const getProfileDetails = () => {
  golfStore.fetchProfile(props.id)
}

const handleUpdateStatus = async (newStatus: string) => {
  if (!golfStore.currentProfile) return
  const profileId = golfStore.currentProfile.id

  if (
    newStatus === 'active' &&
    golfStore.currentProfile.status === 'admin_blocked'
  ) {
    await golfStore.unblockProfile(profileId)
  } else {
    await golfStore.updateProfile(profileId, {
      status: newStatus as 'active' | 'inactive' | 'admin_blocked',
    })
  }
}

const handleUploadImage = async (event: Event, type: string) => {
  const input = event.target as HTMLInputElement
  const file = input.files?.[0]
  if (!file || !golfStore.currentProfile) return

  const formData = new FormData()
  formData.append('image', file)
  formData.append('type', type)

  await golfStore.createImage(golfStore.currentProfile.id, formData)
}

const handleDeleteImage = async (imageId: string) => {
  await golfStore.deleteImage(imageId)
}

const handleUpdateProfile = async (payload: {
  name?: string
  model_name?: string
  seats?: number
  description?: string
  geo_zone_map_url?: string
  tariff_ids?: string[]
  tariff_id?: string
}) => {
  const apiPayload: any = { ...payload }
  if (payload.tariff_id !== undefined) {
    apiPayload.tariff_ids = payload.tariff_id ? [payload.tariff_id] : []
    delete apiPayload.tariff_id
  }
  await golfStore.updateProfile(props.id, apiPayload)
  await golfStore.fetchProfile(props.id)
}

onMounted(() => {
  headerStore.setCustomHeader(true)
  getProfileDetails()
})

onUnmounted(() => {
  headerStore.setCustomHeader(false)
})

return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, {
    direction: "vertical",
    class: "container"
  }, {
    default: _withCtx(() => [
      (_unref(golfStore).error)
        ? (_openBlock(), _createBlock(CommonError, {
            key: 0,
            errorMessage: _unref(golfStore).error,
            onRetryPress: getProfileDetails
          }, null, 8, ["errorMessage"]))
        : (!_unref(golfStore).currentProfile)
          ? (_openBlock(), _createBlock(Loader, { key: 1 }))
          : (_openBlock(), _createBlock(_component_el_tabs, {
              key: 2,
              modelValue: activeTab.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
              type: "card",
              class: "golf-details-tabs"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  label: _ctx.$t('golf.fleet.car_details'),
                  name: "golf-car-info"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_scrollbar, { always: "" }, {
                      default: _withCtx(() => [
                        _createVNode(GolfCarInfoSection, {
                          profile: _unref(golfStore).currentProfile,
                          onUpdateStatus: handleUpdateStatus,
                          onUploadImage: handleUploadImage,
                          onDeleteImage: handleDeleteImage,
                          onUpdateProfile: handleUpdateProfile
                        }, null, 8, ["profile"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_tab_pane, {
                  label: _ctx.$t('golf.fleet.physical_assets'),
                  name: "assets",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_scrollbar, { always: "" }, {
                      default: _withCtx(() => [
                        _createVNode(GolfCarAssetsSection, {
                          profile: _unref(golfStore).currentProfile
                        }, null, 8, ["profile"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue"]))
    ]),
    _: 1
  }))
}
}

})